module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.15a9ef5c.jpeg";